var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisionCatalogChangedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "theaters_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.069,
    height: 27.069,
    viewBox: "0 0 27.069 27.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M0,0H27.069V27.069H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M21.369,3V5.406H18.888V3H8.963V5.406H6.481V3H4V24.655H6.481V22.249H8.963v2.406h9.925V22.249h2.481v2.406h2.481V3ZM8.963,19.843H6.481V17.437H8.963Zm0-4.812H6.481V12.625H8.963Zm0-4.812H6.481V7.812H8.963Zm12.407,9.625H18.888V17.437h2.481Zm0-4.812H18.888V12.625h2.481Zm0-4.812H18.888V7.812h2.481Z",
    transform: "translate(-0.391 -0.293)",
    fill: "#62b0dc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionCatalogChangedIcon);
export default __webpack_public_path__ + "static/media/VisionCatalogChangedIcon.dbc476286a6ba89bb24e2606e3d99b3b.svg";
export { ForwardRef as ReactComponent };